import React, { useEffect, useState } from "react";
import { format, parse } from "date-fns";
import frLocale from "date-fns/locale/fr";
import { Helmet } from "react-helmet";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import RefreshIcon from "@material-ui/icons/Refresh";
import Paper from "@material-ui/core/Paper";
import UiButton from "../../common/UiButton";
import UiInput from "../../common/UiInput";
import UiFormTitle from "../../common/UiFormTitle";
import MetadataFilterBuilder from "./MetadataFilterBuilder";
import { Calendar } from "../../common/Calendar";

const ImportEsForm = (props: any) => {
  const { classes, history, importEs, countEs, project, numberImages, metadatas } =
    props;

  const [datas, setDatas] = useState<any>({});
  const [error, setError] = useState<string>("");
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [dDebut, setDateDebut] = useState<any>(new Date());
  const [dFin, setDateFin] = useState<any>(new Date());
  const [filterMetadatas, setFilterMetadatas] = useState<any>([]);

  useEffect(() => {
    setDatas((d: any) => ({ ...d, projectId: project.id }));
  }, [project]);

  const d = new Date();
  const dUTCOffset = d.getTimezoneOffset() / 60;
  const sign = dUTCOffset < 0 ? "+" : "-";
  const offset = dUTCOffset < 10 ? `0${dUTCOffset * -1}` : `${dUTCOffset * -1}`;
  const offsetComplet = `${sign}${offset}:00`;

  const handleChange = (e: any) => {
    if (error) {
      setError("");
    }
    setDatas({
      ...datas,
      [e.target.name]: e.target.value,
    });
  };

  const submit = (e: any) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    const { subFolderName, projectId } = datas;

    importEs({
      projectId,
      subFolderName,
      dateFrom: `${format(parse(dDebut), `YYYY-MM-DDTHH:mm:[00]${offsetComplet}`, {
        locale: frLocale,
      })}`,
      dateTo: `${format(parse(dFin), `YYYY-MM-DDTHH:mm:[59]${offsetComplet}`, {
        locale: frLocale,
      })}`,
      filterMetadatas,
    })
      .then(() => {
        setSubmitting(false);
        setTimeout(() => history.push("/projectsOperations", 2000));
      })
      .catch(() => setSubmitting(false));
  };

  const handleCountImages = (e: any) => {
    e.preventDefault();
    const { projectId } = datas;
    countEs({
      projectId,
      dateFrom: `${format(parse(dDebut), `YYYY-MM-DDTHH:mm:[00]${offsetComplet}`, {
        locale: frLocale,
      })}`,
      dateTo: `${format(parse(dFin), `YYYY-MM-DDTHH:mm:[59]${offsetComplet}`, {
        locale: frLocale,
      })}`,
      filterMetadatas,
    }).then(() => console.info("ok"));
  };

  const handleMetadatasChange = (filters: any) => {
    setFilterMetadatas(
      filters.filter((f: any) => f.key.length > 0 && f.value.length > 0)
    );
  };

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="flex-start"
      className={classes.root}
    >
      <Helmet>
        <title>Importer des images</title>
      </Helmet>
      <Grid item sm={8}>
        <Paper className={classes.paper}>
          <UiFormTitle>{`Importer les images ${
            project.name ? `pour le projet ${project.name}` : ""
          }`}</UiFormTitle>
          <form onSubmit={submit} id="form">
            <Grid
              container
              spacing={8}
              direction="row"
              justify="space-between"
              className={classes.form}
            >
              <Grid item sm={6}>
                <UiInput
                  label="Dossier de stockage"
                  autoFocus
                  name="subFolderName"
                  required
                  onChange={handleChange}
                  value={datas.subFolderName ?? ""}
                  tabIndex={2}
                />
              </Grid>
              <Grid item sm={6}>
                <label className={classes.label}>
                  Sélectionnez une période <sup>*</sup>
                </label>
                <Calendar
                  istartDate={dDebut}
                  iendDate={dFin}
                  isSeconds={false}
                  isAm={false}
                  handleChangeStartDate={setDateDebut}
                  handleChangeEndDate={setDateFin}
                />
              </Grid>
              <Grid item sm={6}>
                <MetadataFilterBuilder
                  metadatas={metadatas}
                  onChange={handleMetadatasChange}
                />
              </Grid>
              <Grid item sm={6}>
                <Grid
                  container
                  direction="row"
                  justify="flex-end"
                  alignItems="center"
                  spacing={8}
                  style={{ height: "100%" }}
                >
                  <Grid item sm={6}>
                    {`Nombre d'images : ${numberImages !== null ? numberImages : "..."}`}
                  </Grid>
                  <Grid item sm={2}>
                    <IconButton onClick={handleCountImages}>
                      <RefreshIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item sm={12}>
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  spacing={16}
                >
                  <Grid item sm={8}>
                    {error !== "" && (
                      <div style={{ marginTop: 16 }}>
                        <span style={{ color: "red" }}>Erreur : {error}</span>
                      </div>
                    )}
                  </Grid>
                  <Grid item sm={4}>
                    <UiButton
                      style={{ marginTop: 16 }}
                      fullWidth
                      color="secondary"
                      variant="contained"
                      type="submit"
                      tabIndex={3}
                      disabled={submitting || error !== ""}
                    >
                      {submitting
                        ? "Import des images en cours..."
                        : "Importer vos images"}
                    </UiButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ImportEsForm;
